module.exports = __webpack_public_path__ + "static/img/101tgimg.ac3d2a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/101tgimg.jpg
// module id = fMOi
// module chunks = 2